import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from 'core/components/tooltip';
import useStyles from './requires-water-backup-tag.styles';

const TOOLTIP_TEXT =
  "In order to add this coverage, this risk must have water backup. If you add this coverage, we'll " +
  'automatically turn on and set water backup to match your inland flood limit. Water backup must match ' +
  'inland flood when both are applied.';

const RequiresWaterBackupTag = ({ coverageWaterBackup }) => {
  const classes = useStyles();

  if (Number(coverageWaterBackup) > 0) {
    return null;
  }

  return (
    <div className={classes.requiresWaterBackupTag}>
      Requires water backup
      <Tooltip text={TOOLTIP_TEXT} placement="top" />
    </div>
  );
};

RequiresWaterBackupTag.propTypes = {
  coverageWaterBackup: PropTypes.number
};

RequiresWaterBackupTag.defaultProps = {
  coverageWaterBackup: null
};

export default RequiresWaterBackupTag;
